import { SimilaritySearchResponseDto } from "generated";
import api from "./services/api/axios-client";

export const bynderBaseUrl =
  import.meta.env.VITE_ENV !== "prod"
    ? "https://ikea-demo.getbynder.com"
    : "https://ikea.getbynder.com/";

export type SimilarFilesResponse = Record<string, SimilaritySearchResponseDto>;

export const fetchSimilarAssetsByUploadedFiles = async (files: File[]) => {
  return api.assetsControllerFindSimilarFiles({ files }).then((results) =>
    results.data.reduce((acc: SimilarFilesResponse, current) => {
      acc[current.filename] = current;
      return acc;
    }, {} as SimilarFilesResponse),
  );
};
